/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const SINGLE_NDC_DETAIL = 'SINGLE_NDC_DETAIL';
export const SINGLE_ACC_REC_NDC__DETAIL_TABLE =
  'SINGLE_ACC_REC_NDC__DETAIL_TABLE';
export const NDC_BALANCE_DUE = 'NDC_BALANCE_DUE';
export const NDC_OVERRIDDEN = 'NDC_OVERRIDDEN';
export const NDC_PAID_FULL = 'NDC_PAID_FULL';
export const MODIFICATION_FROM_AR = 'MODIFICATION_FROM_AR';
export const AR_NDC_DETAIL_FIRST_LOAD = 'AR_NDC_DETAIL_FIRST_LOAD';
export const ACCOUNT_REC_NDC_DETAIL_CLEAR_REDUX =
  'ACCOUNT_REC_NDC_DETAIL_CLEAR_REDUX';
